// authConfig.ts
import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { getRuntimeConfig } from "./runtimeConfig";

const getMsalConfig = (): Configuration => {
  try {
    const rc = getRuntimeConfig();
    return {
      auth: {
        clientId: rc.msalClientId,
        authority: rc.msalAuthority,
        redirectUri: rc.msalRedirectUri,
        postLogoutRedirectUri: rc.msalPostLogoutRedirectUri,
        navigateToLoginRequestUrl: false, //Terk Amendment 20260816 : prevent MSAL from restoring/compounding a stale or malformed pre-login path (e.g. /QuickAdd/QuickAdd 404), always return to the bare redirectUri
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  } catch {
    // Fallback for dev / before runtime config is loaded
    return {
      auth: {
        clientId: "398ae170-b003-46bc-9cb5-f71fe9f0f9d8",
        authority:
          "https://login.microsoftonline.com/fe9c4641-3b53-43d0-af72-8f3e64d3aa05",
        redirectUri: "https://eec.dksh.com",
        postLogoutRedirectUri: "https://eec.dksh.com",
        navigateToLoginRequestUrl: false, //Terk Amendment 20260816 : prevent MSAL from restoring/compounding a stale or malformed pre-login path (e.g. /QuickAdd/QuickAdd 404), always return to the bare redirectUri
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  }
};

export const msalConfig: Configuration = getMsalConfig();

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
  ],
};


export const msalInstance = new PublicClientApplication(msalConfig);


